/**
 * プレビューの設定（大きさ・軽さ・fps の表示）の入力欄。選べる軽さの一覧と大きさの範囲は呼ぶ側が渡す。
 */
export default function PreviewSettings({ qualities = [], value, onChange, heightRange = null }) {
  return (
    <div data-testid="preview-settings" style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', fontSize: 12 }}>
      {heightRange ? (
        <label style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          大きさ
          <input
            type="range" data-testid="preview-height"
            min={heightRange.min} max={heightRange.max} step={heightRange.step} value={value.stageHeight ?? heightRange.def}
            onChange={(e) => onChange({ ...value, stageHeight: Number(e.target.value) })}
          />
          <span style={{ width: 52, fontVariantNumeric: 'tabular-nums' }}>{`${value.stageHeight ?? heightRange.def}px`}</span>
        </label>
      ) : null}
      <label style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        プレビューの画質
        <select
          data-testid="preview-quality" value={value.quality}
          onChange={(e) => onChange({ ...value, quality: e.target.value })}
        >
          {qualities.map((q) => <option key={q.id} value={q.id}>{q.label}</option>)}
        </select>
      </label>
      <label style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        <input type="checkbox" data-testid="preview-fps" checked={Boolean(value.fps)} onChange={(e) => onChange({ ...value, fps: e.target.checked })} />
        fps を出す
      </label>
    </div>
  );
}
